import React from 'react';
import './../../index.css';
import './../../App.scss';
import {
  DefaultBackgroundImage,
  HeaderContainer,
  Message,
  ModalContainer,
  ModalContent,
  ModalMainBodyStyle,
  SocialModalStyle,
  HeaderContnet,
  HeaderItem,
  NeedsHelpText,
} from './styledComponents';
import Modal from '../../components/JSModal';
import { onPressHelp } from 'shared/utils/redirectionHelp';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';

export default function GeoBlock({ status, message }) {
  return (
    <>
      <DefaultBackgroundImage alt="background" src={assetSource(ASSET_KEY.LOBBY_BACKGROUND)} />
      <Modal
        customBackground
        hideCloseButton={true}
        hideOverlay={false}
        isVisible={status === 1}
        modalMainBodyStyle={ModalMainBodyStyle}
        onBackButtonPress={() => null}
        style={SocialModalStyle}
        zIndex={9999}
      >
        <ModalContainer>
          <HeaderContainer
            ibw={require(asset`full-modal-header.ibw`)}
            position="absolute"
            source={assetSource(ASSET_KEY.FULL_MODAL_HEADER)}
          >
            <HeaderContnet>
              <HeaderItem />
              <HeaderItem />
              <HeaderItem justify={'flex-end'}>
                <NeedsHelpText onClick={onPressHelp}>Need Help?</NeedsHelpText>
              </HeaderItem>
            </HeaderContnet>
          </HeaderContainer>
          <ModalContent withButton={false}>
            <Message>
              {message || "We're sorry, this app is not available in your location due to geo-restriction."}
            </Message>
          </ModalContent>
        </ModalContainer>
      </Modal>
    </>
  );
}

